document.addEventListener('DOMContentLoaded', function() {

  if (!window.COG_PRICES) return;

  const servings = window.COG_BIG_SERVINGS || 90;
  const bigPrice = window.COG_BIG_PRICE || 0;
  const perDay = (bigPrice / servings).toFixed(1);

  const servingLabel = document.getElementById('cog-big-serving-label');
  const dayRate = document.getElementById('cog-big-day-rate');

  if (servingLabel) servingLabel.textContent = servings + ' Servings';
  if (dayRate) dayRate.textContent = '₹' + perDay + '/ Day';

  window.COG_PRICES['big'].btnText = 'Get this Deal (₹' + perDay + '/ Day)';

  const TIERS = {
    '66': {
      price: window.COG_PRICES['66'].price,
      compare: window.COG_PRICES['66'].compare,
      btnText: window.COG_PRICES['66'].btnText,
      qty: 1,
      variantId: window.COG_66_ID
    },
    'big': {
      price: window.COG_PRICES['big'].price,
      compare: window.COG_PRICES['big'].compare,
      btnText: window.COG_PRICES['big'].btnText,
      qty: 1,
      variantId: window.COG_BIG_ID
    }
  };

  const defaultTier = document.querySelector('input[name="cog-bundle-tier"]:checked')?.value;
  if (defaultTier && TIERS[defaultTier]) {
    document.getElementById('cog-bundle-btn-text').textContent = TIERS[defaultTier].btnText;
  }

  function updateUI(tier) {
    const c = TIERS[tier];
    if (!c) return;
    document.getElementById('cog-total-price').textContent = c.price;
    document.getElementById('cog-total-compare').textContent = c.compare;
    document.getElementById('cog-bundle-btn-text').textContent = c.btnText;
    document.querySelectorAll('.cog-bundle-option').forEach(function(opt) {
      opt.classList.toggle('cog-bundle-option--selected', opt.dataset.tier === tier);
    });
  }

  document.querySelectorAll('input[name="cog-bundle-tier"]').forEach(function(radio) {
    radio.addEventListener('change', function(e) { updateUI(e.target.value); });
  });

  const addBtn = document.getElementById('cog-bundle-add-btn');
  if (addBtn) {
    addBtn.addEventListener('click', async function() {
      const btn = document.getElementById('cog-bundle-add-btn');
      const btnText = document.getElementById('cog-bundle-btn-text');
      const btnLoading = document.getElementById('cog-bundle-btn-loading');
      const errorEl = document.getElementById('cog-bundle-error');

      const tier = document.querySelector('input[name="cog-bundle-tier"]:checked')?.value;
      if (!tier) return;

      const config = TIERS[tier];
      const variantId = config.variantId;

      btn.disabled = true;
      btnText.style.display = 'none';
      btnLoading.style.display = 'inline';
      errorEl.style.display = 'none';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });
        if (!res.ok) throw new Error();

        window.location.href = '/cart';

      } catch(e) {
        errorEl.style.display = 'block';
        btn.disabled = false;
        btnText.style.display = 'inline';
        btnLoading.style.display = 'none';
      }
    });
  }

});